import { createStore } from 'vuex'

export default {
  name: 'store',
  install(app, Launcher, ops) {
    let store

    if (ops) {
      store = createStore({
        ...ops,
        strict: ops.strict || process.env.NODE_ENV !== 'production',
      })
    } else {
      store = createStore({
        strict: process.env.NODE_ENV !== 'production',
      })
    }

    if (process.env.BROWSER) {
      if (window['__INITIAL_STATE__']) { // eslint-disable-line
        store.replaceState(window['__INITIAL_STATE__']) // eslint-disable-line
      }
    }

    app.vm.use(store)
    app.store = store
  },
}
